import { createRouter, createWebHistory } from "vue-router";

import store from "../store";
import ShopsView from "../views/ShopsView";
import ShopDetailView from "../views/ShopDetailView";
import LogIn from "../views/LogIn";
import NotFound from "@/components/NotFound";
// import ShopStatus from "../views/ShopStatus";

const routes = [
  {
    path: "/",
    name: "Home",
    component: ShopsView,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: "/shops",
    name: "Shops",
    component: ShopsView,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: "/:shop_slug/",
    name: "ShopDetail",
    component: ShopDetailView,
    meta: {
      requireLogin: true,
    },
  },
  // {
  //   path: "/:shop_slug/status",
  //   name: "ShopStatus",
  //   component: ShopStatus,
  //   meta: {
  //     requireLogin: true,
  //   },
  // },
  {
    path: "/log-in",
    name: "LogIn",
    component: LogIn,
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((record) => record.meta.requireLogin) &&
    !store.state.isAuthenticated
  ) {
    next({ name: "LogIn", query: { to: to.path } });
  } else {
    next();
  }
});

export default router;
